export const environment = {
    production: false,
        // Shared with SM.API (ApiClientGate__ClientKey) - the two MUST match.
    // Not a secret: it ships in this bundle. Its purpose is that a browser never
    // sends it on its own, so the API can refuse address-bar hits, links and iframes
    // that would otherwise ride the ambient SM.Auth cookie.
    smClientKey: 'sm-client-dev',
    // Tenant-specific API URLs for DEV environment
    // Tenant is resolved from a matching URL path segment (see src/app/shared/tenant.util.ts)
    // Example: https://localhost:4200/sm_boeing_dev/... -> tenants["sm_boeing_dev"]
    tenants: {
        // Boeing SM Application (from MAG)
        sm_boeing_dev: 'https://sm-boeing.exostardev.com/API',
        boeing: 'https://sm-boeing.exostardev.com/API'
    } as { [key: string]: string },
    
    // Authentication configuration
    auth: {
      loginUrl: '/auth/startlogin',
      logoutUrl: '/auth/logout',
      userInfoUrl: '/auth/userinfo',
    },
    
    // MAG Portal Login URL for DEV environment
    // Redirect here when no tenant specified and user not authenticated
    magLoginUrl: 'https://ui.portal.exostardev.com',
    
    // Form Editor URL
    formEditorUrl: '',
    homePageUrl: 'https://ui-sm.exostardev.com/obmui',
    formDesignerUrl: 'https://ui-sm-fd.exostardev.com/formdesigner',
    reportingToolUrl: 'https://ui-sm-reporting.exostardev.com'
  };